import React, { useState, useEffect } from 'react';
import { initGA } from '../utils/analytics';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { X, Cookie, Shield } from 'lucide-react';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [consent, setConsent] = useState({
      necessary: true,
      analytics: false,
      functional: false,
      marketing: false,
    });

  useEffect(() => {
    const savedConsent = localStorage.getItem('cookieConsent');
    if (!savedConsent) setShowBanner(true);
  }, []);

  const handleSaveConsent = () => {
    localStorage.setItem('cookieConsent', JSON.stringify(consent));
    setShowBanner(false);

    if (consent.analytics) {
      const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;
      if (measurementId) initGA(measurementId);
    }

    if (consent.functional) {
      // Telegram-URL aufrufen oder Funktion aktivieren
    }

    console.log('Consent gespeichert:', consent);
  };

  const handleAcceptAll = () => {
    const allConsent = {
      necessary: true,
      analytics: true,
      functional: true,
      marketing: true,
    };
    setConsent(allConsent);
    localStorage.setItem('cookieConsent', JSON.stringify(allConsent));
    setShowBanner(false);

    const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;
    if (measurementId) initGA(measurementId);

    // Telegram etc. aktivieren
    console.log('Alle Cookies akzeptiert');
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-6 left-6 right-6 z-50">
      <Card className="p-6 bg-white shadow-xl">
        <h3 className="font-bold text-slate-900 mb-2">Cookie-Einstellungen</h3>
        <p className="text-sm text-slate-600 mb-4">
          Wir verwenden Cookies, um unsere Website zu verbessern und Dienste bereitzustellen.
        </p>

        <div className="space-y-2 mb-4">
          <label><input type="checkbox" checked disabled /> Technisch notwendig</label><br />
          <label><input type="checkbox" checked={consent.analytics} onChange={() => setConsent(c => ({ ...c, analytics: !c.analytics }))} /> Analyse (Google Analytics)</label><br />
          <label><input type="checkbox" checked={consent.functional} onChange={() => setConsent(c => ({ ...c, functional: !c.functional }))} /> Funktional (Telegram)</label><br />
          <label><input type="checkbox" checked={consent.marketing} onChange={() => setConsent(c => ({ ...c, marketing: !c.marketing }))} /> Marketing</label><br />
        </div>

        <div className="flex space-x-3">
          <Button onClick={handleSaveConsent}>Auswahl speichern</Button>
          <Button onClick={handleAcceptAll} className="bg-blue-600 text-white">Alle akzeptieren</Button>
        </div>
      </Card>
    </div>
  );
};

export default CookieBanner;